import mergeWith from 'lodash-es/mergeWith';
import get from 'lodash-es/get';
import { isValidElement, ReactNode } from 'react';

import { logger } from '@digital-dealer/utils';
import { LOCALE } from '@digital-dealer/environments';

import basicTexts from './basicTexts';
import TTextsOverride from './types/TTextsOverride';

class TextsService {
  private texts: Record<string, any> = basicTexts[LOCALE];

  public get = <ReturnType = string>(key: string): ReturnType => {
    const value = get(this.texts, key);

    if (typeof value === 'undefined') {
      logger.trackWarning(`TextsService. Value for ${key} is missing`, {
        catcher: 'TextsService.get',
      });

      return key as unknown as ReturnType;
    }

    return value;
  };

  public override = (newTexts: TTextsOverride): void => {
    const mergeCustomizer = (objValue: ReactNode, srcValue: ReactNode): unknown => {
      /**
       * If source prop is a valid JSX element -> copy by link as it is.
       * If default merge method is used - internal react-dom issues occur since original fiber nodes links are lost
       */
      if (isValidElement(srcValue)) {
        return srcValue;
      }

      /**
       * If not -> use default built-in merge rule
       */
      return undefined;
    };

    this.texts = mergeWith({}, this.texts, newTexts[LOCALE], mergeCustomizer);
  };
}

export default new TextsService();
